import React, { useEffect, useState } from 'react';
import Pagination from '../../atom/Pagination';
import Typo from '../../atom/Typo';
import Select from '../../atom/Select';

interface PaginationWithPageSizeProps {
  total: number;
  page: number;
  pageSize: number;
  handlePaginationClick: (page: number, pageSize: number) => void;
}

function PaginationWithPageSize({
  total,
  page,
  pageSize,
  handlePaginationClick,
}: PaginationWithPageSizeProps) {
  const [selectPageSize, setSelectPageSize] = useState(pageSize.toString());

  useEffect(() => {
    setSelectPageSize(pageSize.toString());
  }, [pageSize]);

  return (
    <div className="relative flex items-center justify-between pt-4">
      <Typo typoType="b14r">Total {total}</Typo>

      <div className="absolute left-[50%] translate-x-[-50%]">
        <Pagination
          total={total}
          page={page}
          pageSize={Number(selectPageSize)}
          onChangePage={page => {
            handlePaginationClick(page, Number(selectPageSize));
          }}
        />
      </div>

      <Select
        rootProps={{
          value: selectPageSize,
          onValueChange: pageSize => {
            handlePaginationClick(1, Number(pageSize));
            setSelectPageSize(pageSize);
          },
        }}
        triggerProps={{
          className: 'w-[110px]',
        }}
        allowClear={false}
        option={[
          {
            optionList: [
              { label: '10/page', value: '10' },
              { label: '30/page', value: '30' },
              { label: '50/page', value: '50' },
              { label: '100/page', value: '100' },
            ],
          },
        ]}
      />
    </div>
  );
}

export default PaginationWithPageSize;
